import React, { useState } from 'react';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import './index.scss';
import TextBubbles from '@/pages/home/components/TextBubbles';

const InfoCard = (props: any) => {
  const { infoList, defaultImg } = props;
  return (
    <CardSlot className='dbi-infocard-card'>
      <div className="dbi-infocard">
        <div className='dbi-infocard-img'>
          <img
            src={infoList?.image_url || infoList?.imageUrl}
            alt=""
            onError={(e: any) => {
              e.target.src = defaultImg;
            }}
          />
        </div>
        <div className='dbi-infocard-info'>
          <div className='dbi-infocard-title'>{infoList?.name || infoList?.title}</div>
          {/* <div className='dbi-infocard-text'>{infoList?.short_description || infoList?.personIdentifierValue}</div> */}
          <TextBubbles className="dbi-infocard-text" placement="top" text={infoList?.short_description || infoList?.personIdentifierValue}/>
        </div>
      </div>
    </CardSlot>
  )
}
export default InfoCard